/*
 * Wishlist and Compare have no native Shopify data model (they were the `whishlist` and
 * `compare` DB tables). This implements both client-side with localStorage, keyed by
 * product handle, and rendered via Shopify's public /products/{handle}.js AJAX endpoint —
 * no app or backend required. Swapping in a wishlist/compare app later just means removing
 * this file and the two data-product-handle buttons in product-card.liquid / main-product.liquid.
 *
 * "Add to cart" itself is NOT handled here — product-card.liquid links straight to the
 * product page, and main-product.liquid's Add to Cart button is a real
 * {% form 'product', product %} submit, both native Shopify behavior needing no JS.
 */
(function () {
  var STORE_KEYS = { wishlist: 'voltz:wishlist', compare: 'voltz:compare' };
  var COMPARE_LIMIT = 4;

  function readList(key) {
    try {
      return JSON.parse(localStorage.getItem(key)) || [];
    } catch (e) {
      return [];
    }
  }

  function writeList(key, list) {
    try {
      localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable (private mode, quota) — fail silently, nothing to persist */
    }
  }


  /*
   * Still required even though no click handler in this file calls it: it is exported on
   * window.VoltzLists below and used by the Remove button on the wishlist page
   * (main-wishlist.liquid). Removing it left that export referencing an undefined name, which
   * threw before VoltzLists was assigned and silently emptied both the wishlist and compare
   * pages - they read their handles through that global.
   */
  function toggle(key, handle, limit) {
    var list = readList(key);
    var index = list.indexOf(handle);
    if (index > -1) {
      list.splice(index, 1);
      writeList(key, list);
      return { added: false };
    }
    if (limit && list.length >= limit) {
      // Matches Laravel's AddToCompare: blocks at the limit ("Limit Exceed For Compare")
      // instead of silently evicting the oldest item.
      return { added: false, limitExceeded: true };
    }
    list.push(handle);
    writeList(key, list);
    return { added: true };
  }

  function refreshButtonStates() {
    var wishlist = readList(STORE_KEYS.wishlist);
    var compare = readList(STORE_KEYS.compare);
    document.querySelectorAll('.btn-wishlist[data-product-handle]').forEach(function (btn) {
      btn.classList.toggle('active', wishlist.indexOf(btn.dataset.productHandle) > -1);
    });
    document.querySelectorAll('.btn-compare[data-product-handle]').forEach(function (btn) {
      btn.classList.toggle('active', compare.indexOf(btn.dataset.productHandle) > -1);
    });
  }

  /*
   * theme-vendor-main.js appends its own compare popup to .page-wrapper with a hardcoded
   * relative link:  <a href="compare" class="btn btn-dark btn-rounded">Start Compare !</a>
   * On Laravel that resolves to /compare, which is its real compare page. Here the page lives
   * at /pages/compare, so the button landed on the wrong URL. The popup is created by that
   * script (and re-created as products are added), so the link is corrected whenever it appears.
   */
  /*
   * The add-to-cart Minipopup has the same defect, and it is worse because it is relative
   * rather than merely pointing at the wrong page:
   *   <a href="cart" class="btn btn-success btn-rounded">View Cart</a>
   * A bare "cart" resolves against the current path, so it only works at the site root:
   *   /                  -> /cart              (works, which is why the home page looked fine)
   *   /collections/all   -> /collections/cart  (404)
   *   /products/xyz      -> /products/cart     (404)
   * Same for the "checkout" link in that popup. Both are rewritten to absolute paths.
   */
  function fixVendorPopupLinks() {
    document.querySelectorAll('.compare-popup a[href="compare"], .compare-popup a[href="/compare"]')
      .forEach(function (a) { a.setAttribute('href', '/pages/compare'); });
    document.querySelectorAll('a[href="cart"]')
      .forEach(function (a) { a.setAttribute('href', '/cart'); });
    document.querySelectorAll('a[href="checkout"]')
      .forEach(function (a) { a.setAttribute('href', '/checkout'); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    refreshButtonStates();
    fixVendorPopupLinks();
    /*
     * The popups are injected into .page-wrapper after load, and re-created on each add, so
     * body is observed as a fallback for pages where .page-wrapper is absent - otherwise the
     * rewrite never runs on exactly the pages that need it.
     */
    var wrapper = document.querySelector('.page-wrapper') || document.body;
    if (wrapper && window.MutationObserver) {
      new MutationObserver(fixVendorPopupLinks).observe(wrapper, { childList: true, subtree: true });
    }
  });

  document.addEventListener('click', function (e) {
    var wishBtn = e.target.closest('.btn-wishlist[data-product-handle]');
    if (wishBtn) {
      /*
       * Mirrors SiteIndexController::AddToWhishList, which adds only - it never removes.
       * A second click on an item already saved returns "Item Already In whishlist" rather
       * than deleting it; removal happens on the wishlist page (DeleteWhishlist), which is
       * where .remove-wishlist in main-wishlist.liquid does the same job.
       *
       * This previously toggled silently, so a second click quietly removed the item and no
       * click gave any feedback. Messages are Laravel's, verbatim, lowercase "whishlist" and
       * all - same approach as the compare handler below.
       */
      e.preventDefault();
      var wishHandle = wishBtn.dataset.productHandle;
      var wishList = readList(STORE_KEYS.wishlist);

      if (wishList.indexOf(wishHandle) > -1) {
        alert('Item Already In whishlist');
        return;
      }
      wishList.push(wishHandle);
      writeList(STORE_KEYS.wishlist, wishList);
      wishBtn.classList.add('active');
      alert('Item has Been Added To whishlist');
      return;
    }

    var compareBtn = e.target.closest('.btn-compare[data-product-handle]');
    if (compareBtn) {
      /*
       * The Wolmart demo script also binds ".product .btn-compare", calls preventDefault and
       * just toggles an icon plus a decorative popup - no data is stored. preventDefault does
       * not stop this listener, so the real list is maintained here.
       *
       * Messages and the 4-item cap mirror SiteIndexController::AddToCompare exactly, including
       * its behaviour of refusing a duplicate rather than removing it.
       */
      e.preventDefault();
      var handle = compareBtn.dataset.productHandle;
      var list = readList(STORE_KEYS.compare);

      if (list.indexOf(handle) > -1) {
        alert('Item Already In Compare');
        return;
      }
      if (list.length >= COMPARE_LIMIT) {
        alert(' Limit Exceed For Compare');
        return;
      }
      list.push(handle);
      writeList(STORE_KEYS.compare, list);
      compareBtn.classList.add('active');
      alert('Item has Been Added To Compare');
      return;
    }

    var quickViewBtn = e.target.closest('.btn-quickview[data-product-handle]');
    if (quickViewBtn) {
      e.preventDefault();
      openQuickView(quickViewBtn.dataset.productHandle);
    }
  });

  // --- Quick view (port of resources/views/quick-view.blade.php + AJAX addcart) ---
  // Markup mirrors snippets/quick-view.liquid; injected once into <body> on first use
  // since the trigger button lives in product-card.liquid, which renders once per
  // product in a grid (rendering the Liquid snippet there would duplicate the id).
  var quickViewModalHtml =
    '<div class="quick-view-modal mfp-hide" id="quick-view-modal">' +
      '<div class="quick-view-content">' +
        '<div class="row">' +
          '<div class="col-md-5"><figure class="product-image"><img id="quick-view-image" src="" alt=""></figure></div>' +
          '<div class="col-md-7">' +
            '<h2 class="product-title" id="quick-view-title"></h2>' +
            '<div class="product-price" id="quick-view-price"></div>' +
            '<div class="product-short-desc" id="quick-view-desc"></div>' +
            '<div class="product-form-wrapper">' +
              '<div class="product-form product-variation-form" id="quick-view-variants" hidden>' +
                '<label>Options:</label><select id="quick-view-variant-select" class="form-control"></select>' +
              '</div>' +
              '<div class="product-qty-form"><div class="input-group"><input type="number" id="quick-view-qty" class="qtyy form-control" min="1" value="1"></div></div>' +
              '<button type="button" id="quick-view-add-to-cart" class="btn btn-primary add_to_cart btn-cart"><i class="w-icon-cart"></i><span>Add to Cart</span></button>' +
              ' <a href="#" id="quick-view-full-link" class="btn btn-outline">View full details</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';

  function ensureQuickViewModal() {
    var modal = document.getElementById('quick-view-modal');
    if (modal) return modal;
    document.body.insertAdjacentHTML('beforeend', quickViewModalHtml);
    modal = document.getElementById('quick-view-modal');

    document.getElementById('quick-view-variant-select').addEventListener('change', renderQuickViewVariant);
    document.getElementById('quick-view-add-to-cart').addEventListener('click', addQuickViewToCart);
    return modal;
  }

  var quickViewProduct = null;

  function money(cents) {
    return (cents / 100).toFixed(2);
  }

  function renderQuickViewVariant() {
    if (!quickViewProduct) return;
    var select = document.getElementById('quick-view-variant-select');
    var variant = quickViewProduct.variants.filter(function (v) {
      return String(v.id) === select.value;
    })[0] || quickViewProduct.variants[0];

    var priceHtml = '<ins class="new-price">' + money(variant.price) + '</ins>';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceHtml += ' <del class="old-price">' + money(variant.compare_at_price) + '</del>';
    }
    document.getElementById('quick-view-price').innerHTML = priceHtml;

    var addBtn = document.getElementById('quick-view-add-to-cart');
    addBtn.dataset.variantId = variant.id;
    addBtn.disabled = !variant.available;
    addBtn.querySelector('span').textContent = variant.available ? 'Add to Cart' : 'Out Of Stock';

    if (variant.featured_image && variant.featured_image.src) {
      document.getElementById('quick-view-image').src = variant.featured_image.src;
    }
  }

  function openQuickView(handle) {
    var modal = ensureQuickViewModal();

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product) return;
        quickViewProduct = product;

        document.getElementById('quick-view-title').textContent = product.title;
        document.getElementById('quick-view-desc').textContent =
          (product.description || '').replace(/<[^>]*>/g, '').split(' ').slice(0, 40).join(' ');
        document.getElementById('quick-view-image').src = product.featured_image || (product.images[0] || '');
        document.getElementById('quick-view-image').alt = product.title;
        document.getElementById('quick-view-full-link').href = '/products/' + product.handle;
        document.getElementById('quick-view-qty').value = 1;

        var variantSelect = document.getElementById('quick-view-variant-select');
        var variantsWrap = document.getElementById('quick-view-variants');
        if (product.variants.length > 1) {
          variantSelect.innerHTML = product.variants.map(function (v) {
            return '<option value="' + v.id + '">' + v.title + '</option>';
          }).join('');
          variantsWrap.hidden = false;
        } else {
          variantsWrap.hidden = true;
        }

        renderQuickViewVariant();

        if (typeof Wolmart !== 'undefined' && Wolmart.popup) {
          Wolmart.popup({ items: { src: '#quick-view-modal' }, type: 'inline', mainClass: 'mfp-quickview mfp-fadein-popup' });
        } else {
          modal.classList.remove('mfp-hide');
        }
      });
  }

  function addQuickViewToCart() {
    var btn = document.getElementById('quick-view-add-to-cart');
    var variantId = btn.dataset.variantId;
    var qty = parseInt(document.getElementById('quick-view-qty').value, 10) || 1;
    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          alert(data.description || data.message || 'Something Wrong');
        } else {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          window.location.href = '/cart';
        }
      });
  }

  window.VoltzLists = { STORE_KEYS: STORE_KEYS, readList: readList, writeList: writeList, toggle: toggle };
})();

/*
 * Mobile menu reliability.
 *
 * theme-vendor-main.js binds the off-canvas menu like this:
 *   $(".mobile-menu-toggle").on("click", open)
 *   $(".mobile-menu-overlay").on("click", close)
 *   $(".mobile-menu-close").on("click", close)
 *   $(window).on("resize", close)
 *
 * Two problems follow from that:
 *
 * 1. Tapping the search box closed the menu. The handlers are bound to window resize, and on
 *    a phone focusing an input opens the virtual keyboard, which changes the viewport height
 *    and fires resize. Only a WIDTH change is a real orientation or layout change; a
 *    height-only change is the keyboard and must not close anything.
 *
 * 2. The toggle stopped working on some pages. The bindings are direct, attached only to the
 *    elements present when the script ran, so anything that clones or re-renders the header
 *    later (the sticky header behaviour) leaves a visible button with no handler on it.
 *    Delegating from document survives that, and works identically on every page.
 *
 * The vendor handlers are left in place - adding a class that is already there is harmless.
 */
(function () {
  var body = document.body;
  var lastWidth = window.innerWidth;
  var menuOpen = false;

  document.addEventListener('click', function (e) {
    if (e.target.closest('.mobile-menu-toggle')) {
      e.preventDefault();
      menuOpen = true;
      body.classList.add('mmenu-active');
      return;
    }
    if (e.target.closest('.mobile-menu-close') || e.target.closest('.mobile-menu-overlay')) {
      e.preventDefault();
      menuOpen = false;
      body.classList.remove('mmenu-active');
    }
  });

  window.addEventListener('resize', function () {
    var width = window.innerWidth;
    if (width === lastWidth) {
      /* Height-only change: the on-screen keyboard. Undo the vendor's close. */
      if (menuOpen) body.classList.add('mmenu-active');
      return;
    }
    /* Real width change (rotation or a desktop resize): close, and do not depend on the
       vendor handler still being attached to do it. */
    lastWidth = width;
    menuOpen = false;
    body.classList.remove("mmenu-active");
  });
})();
